import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

import axios from 'axios'

// axios.defaults.baseURL = `https://10.4.255.103`

// staging
axios.defaults.baseURL = `https://dev-api.partaiperindo.com`

// prod
// axios.defaults.baseURL = `https://api.partaiperindo.com`
axios.defaults.headers.common = {'Authorization': `Bearer ${localStorage.getItem('token')}`}

Vue.use(VueQuillEditor)

//Pagination
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
